import { mapActions } from 'vuex'
import roles from '../helpers/userRoles'

export default {
  name: 'SideBar',
  data: function () {
    return {
      taskMenuOpen: true,
      financeMenuOpen: false,
      clientsMenuOpen: false
    }
  },
  created () {
    if (this.$router.currentRoute.path.indexOf('/tasks/incoming') < 0 && this.$router.currentRoute.path.indexOf('/ad-agent/tasks') < 0) {
      this.refreshRequests()
    }
  },
  methods: {
    toggleTasksMenu () {
      this.taskMenuOpen = !this.taskMenuOpen
    },
    toggleFinanceMenu () {
      this.financeMenuOpen = !this.financeMenuOpen
    },
    toggleClientsMenu () {
      this.clientsMenuOpen = !this.clientsMenuOpen
    },
    ...mapActions({
      toggleSidebar: 'TOGGLE_SIDEBAR',
      refreshRequests: 'LOAD_OUTGOING_TASKS'
    })
  },
  computed: {
    sidebarHidden () {
      return this.$store.state.appSettings.sidebarHidden
    },
    activeTasksCount () {
      return this.$store.getters.userActiveTasks.length
    },
    allActiveTasksCount () {
      return this.$store.getters.activeTasks.length
    },
    pausedTasksCount () {
      return this.$store.getters.userPausedTasks.length
    },
    storedTasksCount () {
      return this.$store.getters.userStoredTasks.length
    },
    contractedTasksCount () {
      return this.$store.getters.userContractedTasks.length
    },
    outgoingTasksCount () {
      return this.$store.getters.userOutgoingTasks.length
    },
    incomingTasksCount () {
      return this.$store.getters.userOutgoingTasks.length
    },
    acceptedTasksCount () {
      return this.$store.getters.userAcceptedTasks.length
    },
    isUserDirector () {
      return (
        this.$store.getters.role === roles.director
      )
    },
    isUserManagerOrDirector () {
      return (
        this.$store.getters.role === roles.manager ||
        this.$store.getters.role === roles.director
      )
    },
    isAddAgent () {
      return this.$store.getters.role === roles.adAgent
    },
    isCompanyUser () {
      return (
        this.$store.getters.role === roles.manager ||
        this.$store.getters.role === roles.director ||
        this.$store.getters.role === roles.accountant ||
        this.$store.getters.role === roles.master ||
        this.$store.getters.role === roles.designer ||
        this.$store.getters.role === roles.printer ||
        this.$store.getters.role === roles.afterPrinter
      )
    }
  }
}
